import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import {
  onApiCall,
  onArrayApiCall,
} from 'src/app/common/store/generic.reducer';
import { GenericState, IState } from 'src/app/common/store/types';
import { PageResult } from '../../types';
import {
  CurrentUserModel,
  User,
  UserConnectionHistory,
  UserDetailModel,
} from './type';
import { userActions } from './user.actions';
import { Action as ViewAction } from '../view/types';

export interface IUserState extends IState<User> {
  getById: GenericState<UserDetailModel>;
  add: GenericState<User>;
  update: GenericState<User>;
  lockout: GenericState<boolean>;
  getCurrentUser: GenericState<CurrentUserModel>;
  getConnectionHistoriesById: GenericState<UserConnectionHistory[]>;
  getMainSalesTeamById: GenericState<number>;
  getStatusActions: GenericState<ViewAction[]>;
}

export const userInitialState: IUserState = {
  getById: new GenericState<UserDetailModel>(),
  add: new GenericState<User>(),
  update: new GenericState<User>(),
  lockout: new GenericState<boolean>(),
  getCurrentUser: new GenericState<CurrentUserModel>(),
  getConnectionHistoriesById: new GenericState<UserConnectionHistory[]>(),
  getMainSalesTeamById: new GenericState<number>(),
  getStatusActions: new GenericState<ViewAction[]>(),
};

const userReducers = [
  ...onApiCall<UserDetailModel>(userActions.getById, 'getById'),
  ...onApiCall<User>(userActions.add, 'add'),
  ...onApiCall<User>(userActions.update, 'update'),
  ...onApiCall<boolean>(userActions.lockout, 'lockout'),
  ...onApiCall<CurrentUserModel>(userActions.getCurrentUser, 'getCurrentUser'),
  ...onApiCall<UserConnectionHistory[]>(
    userActions.getConnectionHistoriesById,
    'getConnectionHistoriesById',
  ),
  ...onApiCall<number | undefined>(
    userActions.getMainSalesTeamById,
    'getMainSalesTeamById',
  ),
  ...onApiCall<ViewAction[]>(userActions.getStatusActions, 'getStatusActions'),
];

export const userReducer = createReducer(
  userInitialState,
  ...userReducers,
) as ActionReducer<IUserState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return userReducer(state, action);
}
